<p-overlayPanel #op
  [style]="{'width':'526px'}"
  [dismissable]="true"
  [showCloseIcon]="true">

  <div class="container">
    <div class="ui-g">

      <div class="ui-g-12">
        <label class="titulo">Editor de URLs em lote</label>
        <label class="subtitulo">Integrações ativas e inativas serão alteradas.</label>
      </div>

      <div class="container-form">
        <div class="ui-g-12 container-input">
          <span class="md-inputfield">
            <input type="text" 
              class="full-width"
              [(ngModel)]="urlAntiga" 
              name="urlAntiga"
              pInputText>
            <label>Url antiga</label>
          </span>
        </div>
      
        <div class="ui-g-12 container-input">
          <span class="md-inputfield">
            <input type="text" 
              class="full-width"
              [(ngModel)]="urlNova" 
              name="urlNova"
              pInputText>
            <label>Url nova</label>
          </span>
        </div>  
      </div>

      <div class="container-botoes" align="right">
        <span class="footer-item">
          <button 
            pButton 
            type="button"
            class="botao ui-button-secondary"
            (click)="cancelar()"
            label="Cancelar"></button>
        </span>

        <span class="footer-item">
          <button 
            pButton 
            type="button"
            class="botao ui-button-primary"
            (click)="salvar()"
            label="Salvar"></button>
        </span>        
      </div>
  
    </div>
  </div>


</p-overlayPanel>    